import { styled, TableCell, TableFooter as MuiTableFooter } from '@mui/material';

export const StickyTableFooter = styled(MuiTableFooter)(() => ({
  position: 'sticky',
  bottom: 0,
  zIndex: 15,
}));

export const FooterTableCell = styled(TableCell)(({ theme }) => ({
  padding: '8px',
  backgroundColor: theme.palette.grey[100],
  borderTop: `1px solid ${theme.palette.divider}`,
}));
